var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDaoModulePending = function SvgDaoModulePending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 4.5,
    r: 3,
    stroke: "#B2B5B2",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 17.5,
    r: 3,
    stroke: "#B2B5B2",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 31.5,
    r: 3,
    stroke: "#B2B5B2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.558 9C35.1052 11.4627 36 14.3769 36 17.5C36 21.5578 34.4895 25.2628 32 28.0833",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16309 11.5C7.53664 5.63634 13.2853 1.5 20.0001 1.5C21.2023 1.5 22.3736 1.6326 23.5001 1.88397",
    stroke: "#B2B5B2",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16309 23.5001C7.53667 29.3637 13.2853 33.5 20 33.5C20.3784 33.5 20.7537 33.4868 21.1255 33.461",
    stroke: "#B2B5B2",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6668 17.5C26.6668 21.1819 23.6821 24.1667 20.0002 24.1667C16.3183 24.1667 13.3335 21.1819 13.3335 17.5C13.3335 13.8181 16.3183 10.8334 20.0002 10.8334C23.6821 10.8334 26.6668 13.8181 26.6668 17.5ZM14.6667 17.5C14.6667 20.4455 17.0545 22.8333 20 22.8333C22.9455 22.8333 25.3333 20.4455 25.3333 17.5C25.3333 14.5545 22.9455 12.1667 20 12.1667C17.0545 12.1667 14.6667 14.5545 14.6667 17.5Z",
    fill: "#B2B5B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6665 16.8333H22.6665C23.0347 16.8333 23.3332 17.1318 23.3332 17.5C23.3332 17.8681 23.0347 18.1666 22.6665 18.1666H20.6665V20.1666C20.6665 20.5348 20.368 20.8333 19.9998 20.8333C19.6316 20.8333 19.3332 20.5348 19.3332 20.1666V18.1666H17.3332C16.965 18.1666 16.6665 17.8681 16.6665 17.5C16.6665 17.1318 16.965 16.8333 17.3332 16.8333H19.3332V14.8333C19.3332 14.4651 19.6316 14.1666 19.9998 14.1666C20.368 14.1666 20.6665 14.4651 20.6665 14.8333V16.8333Z",
    fill: "#B2B5B2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDaoModulePending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dao-module-pending.3803c565.svg";
export { ForwardRef as ReactComponent };